import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { SharedFormMessages as messages } from '../../shared/forms';
import { TextInput } from './TextInput';
import { FormLabel } from 'react-bootstrap';
import { FieldBlock } from './FieldBlock';

export class DateFieldBlock extends Component {
  getDateTypesInOrder() {
    const dateTypeSperators = ['-', '/', '.', ' '];
    let dateTypes = [];
    for (let i = 0; i < dateTypeSperators.length; i += 1) {
      dateTypes = this.props.dateFormat.split(dateTypeSperators[i]);

      if (dateTypes.length > 1) {
        break;
      }
    }
    return dateTypes;
  }


  getDateInput(dateType) {
    const dateTypeLowered = dateType.toLowerCase();
    if (dateTypeLowered === 'd') {
      return (
        <div className="dob day" key="dob-day">
          <TextInput
            type="text"
            className="form-control form-control-ie"
            field={this.props.dayField}
            maxLength={2}
            isInlineElement
            ariaLabelledBy={this.props.id}
            ariaDescribedBy="dayHelpText"
            onKeyPress={this.numericCharactersOnly}
            hasHelpText
          />
          <span className="understated small" id="dayHelpText" aria-label="Day entered as 2 digits">
            <FormattedMessage {...messages.date.dd} />
          </span>
        </div>
      );
    }

    if (dateTypeLowered === 'm') {
      return (
        <div className="dob month" key="dob-month">
          <TextInput
            type="text"
            className="form-control form-control-ie"
            field={this.props.monthField}
            maxLength={2}
            isInlineElement
            ariaLabelledBy={this.props.id}
            ariaDescribedBy="monthHelpText"
            onKeyPress={this.numericCharactersOnly}
            hasHelpText
          />
          <span className="understated small" id="monthHelpText" aria-label="Month entered as 2 digits">
            <FormattedMessage {...messages.date.mm} />
          </span>
        </div>
      );
    }

    if (dateTypeLowered === 'yyyy') {
      return (
        <div className="dob year" key="dob-year">
          <TextInput
            type="text"
            className="form-control form-control-ie"
            field={this.props.yearField}
            maxLength={4}
            isInlineElement
            ariaLabelledBy={this.props.id}
            ariaDescribedBy="yearHelpText"
            onKeyPress={this.numericCharactersOnly}
            hasHelpText
          />
          <span className="understated small" id="yearHelpText" aria-label="Year entered as 4 digits">
            <FormattedMessage {...messages.date.yyyy} />
          </span>
        </div>
      );
    }

    return null;
  }

  lessThanOrEqual = (maxLimit, event) => {
    if (!isNaN(maxLimit)) {
      const numberEntry = event.target.value + String.fromCharCode(event.charCode);
      if (!isNaN(numberEntry) && Number(numberEntry) <= Number(maxLimit)) {
        return true;
      }
    }
    return false;
  };

  numericCharactersOnly = (event) => {
    const isNumericCharacter = event.charCode >= 48 && event.charCode <= 57;
    let maxLimit = 9999;

    switch (event.target.id) {
      case 'day':
        maxLimit = 31;
        break;
      case 'month':
        maxLimit = 12;
        break;
      default:
        break;
    }

    const withInLimit = this.lessThanOrEqual(maxLimit, event);
    if (!isNumericCharacter || !withInLimit) {
      event.preventDefault();
      event.stopPropagation();
    }
  }


  renderError() {
    const { dayField, monthField, yearField } = this.props;
    return (dayField && dayField.meta.touched && dayField.meta.error) ||
            (monthField && monthField.meta.touched && monthField.meta.error) ||
            (yearField && yearField.meta.touched && yearField.meta.error);
  }


  renderDateInputs() {
    const dateTypes = this.getDateTypesInOrder();
    const elementsToRender = [];
    dateTypes.forEach((dateType) => {
      elementsToRender.push(this.getDateInput(dateType));
    });
    return elementsToRender;
  }

  render() {
    return (
      <FieldBlock xs={this.props.xsSize} mdSize={this.props.mdSize} smSize={this.props.smSize} lgSize={this.props.lgSize} rowClass={this.props.rowClass}>
        <div>
        <div>
          <FormLabel id={this.props.id}>
            {this.props.labelText}
          </FormLabel>
        </div>
        <div className={this.renderError()? "clearfix is-invalid" : ""}>
          {this.renderDateInputs()}
        </div>
        { this.renderError() &&
            <span when="required" className="invalid-feedback">
              <FormattedMessage {...messages.error.required} />
            </span> }
        </div>
      </FieldBlock>
    );
  }
}

DateFieldBlock.propTypes = {
  labelText: PropTypes.object,
  xsSize: PropTypes.number,
  mdSize: PropTypes.number,
  smSize: PropTypes.number,
  lgSize: PropTypes.number,
  rowClass: PropTypes.string,
  dayField: PropTypes.object,
  monthField: PropTypes.object,
  yearField: PropTypes.object,
  id: PropTypes.string,
  dateFormat: PropTypes.string,
};
